module.exports = ":host {\n  width: 100%; }\n  :host mat-form-field {\n    width: 100%; }\n  :host .mat-checkbox {\n    margin-right: 15px; }\n"